export const GET_CNPJ_INFO = '/document'
